import { HttpQuery } from "@/interfaces/httpQuery";
import { PmpConfigForLocations } from "@/interfaces/pmp";
import { PmpMetaHeader } from "@/metadata/pmp";
import { pmpService } from "@/services/pmp.service";
import {
  TableAction,
  TableComponent,
  TablePagination,
  TablePaginationComponent,
  TablePaginationDefault
} from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import Template from "./PmpIntegrationComponent.template.vue";

@Component({
  mixins: [Template],
  components: {
    TableComponent,
    TablePaginationComponent
  }
})
export default class PmpIntegrationComponent extends Vue {
  public loading = false;
  public pmpConfig: PmpConfigForLocations[] = [];
  public headers = PmpMetaHeader;
  public colors = ["white", "#f2f2f2", "#f2f2f2"];
  public tableActions: TableAction[] = [];
  public pagination: TablePagination = { ...TablePaginationDefault };

  public mounted() {
    this.tableActions = [
      {
        icon: "fal fa-pencil",
        class: "table__actions",
        action: this.editIntegration,
        tooltip: this.$t("traceability.edit_integration").toString()
      }
    ];
    this.buildTable(this.pagination);
  }

  public editIntegration(item: PmpConfigForLocations) {
    this.$router.push({
      name: "pmp-edit",
      params: { id: String(item.id) }
    });
  }

  public onChangePage(pagination: TablePagination) {
    this.buildTable(pagination);
  }

  public async getLocationsList(query?: HttpQuery) {
    const locations = await pmpService.getLocationsForPmpConfig(query);
    this.pagination = await pmpService.getPagination();
    return locations;
  }

  protected async buildTable(pagination: TablePagination) {
    this.loading = true;

    const allLocations = await this.getLocationsList({
      per_page: pagination.itemsPerPage,
      page: pagination.currentPage
    });

    const pmpFtpConfigs = await pmpService.getPmpFtpConfig({
      location_id: allLocations.map(location => location.id)
    });

    this.pmpConfig = allLocations.map(location => {
      location.pmp_config = pmpFtpConfigs.filter(
        config => config.location_id === location.id
      )[0];
      location.config_status =
        location.pmp_config && location.pmp_config.status
          ? "Enabled"
          : "Disabled";
      return location;
    });

    this.loading = false;
  }
}
